/**
 * Champ « Alignement vertical » — position d'une box dans sa colonne de
 * section (les colonnes font toutes la hauteur de la plus grande) ;
 * appliqué par ProposalBoxAlign.
 */
export function puckVerticalAlignField(label = 'Alignement vertical', { stretch = false } = {}) {
  return {
    type: 'select',
    label,
    options: [
      { label: 'Haut', value: 'top' },
      { label: 'Centre', value: 'center' },
      { label: 'Bas', value: 'bottom' },
      // Pour les boxes qui ont un fond à étendre (carte, image).
      ...(stretch ? [{ label: 'Toute la hauteur', value: 'stretch' }] : []),
    ],
  };
}
